import { css } from '@microsoft/fast-element';
import { componentBaseStyles } from '@adaptive-web/adaptive-ui';
import { neutralForegroundRest } from '@adaptive-web/adaptive-ui/migration';

export default css`
	${componentBaseStyles}

	:host {
		display: block flex;
		align-items: flex-start;
		width: 100%;
		flex-direction: column;
		color: ${neutralForegroundRest};
	}

	:host([type=hero]) {
		--height: 500px;
		display: grid;
		grid-template-columns: minmax(0, 8fr);
		height: 500px;
		position: relative;
	}

	:host([type=hero]) ::slotted(:not([name])) {
		grid-column: 1 / span 3;
		align-self: flex-end;
		padding: var(--padding-sm);
		grid-row: 1;
		z-index: 2;
		margin-inline: auto;
	}

	:host([type=hero]) ::slotted([slot=background]) {
		width: 100%;
		height: var(--height);
		padding: 0;
		object-fit: cover;
		grid-row: 1;
		z-index: 0;
	}
`;